import {Column, Entity, JoinTable, ManyToMany, OneToMany, PrimaryGeneratedColumn} from "typeorm";
import { Order } from "./Order";

@Entity()
export class XeroAddress {

	@PrimaryGeneratedColumn({ name:"id" })
	id?: number

	@Column({ nullable: true }) 
  addressType?: string

  @Column({ nullable: true }) 
  addressLine1?: string

  @Column({ nullable: true }) 
  addressLine2?: string

  @Column({ nullable: true }) 
  city?: string

  @Column({ nullable: true }) 
  region?: string

  @Column({ nullable: true }) 
  postalCode?: string

  @Column({ nullable: true }) 
  country?: string

  @Column({ nullable: true }) 
  attentionTo?: string

  @OneToMany(() => Order, (order) => order.address)
  owningOrders?: Order[]

}